module.exports = __webpack_public_path__ + "assets/img/h4.6d41a8fb.jpg";